import React from "react";
import { Box, Typography } from "@mui/material";

/** Convierte `**negrita**` en segmentos { text, bold } */
export function parseBoldSegments(text = "") {
  const value = String(text);
  if (!value.includes("**")) {
    return [{ text: value, bold: false }];
  }

  const segments = [];
  const regex = /\*\*([^*]+)\*\*/g;
  let lastIndex = 0;
  let match = regex.exec(value);

  while (match) {
    if (match.index > lastIndex) {
      segments.push({ text: value.slice(lastIndex, match.index), bold: false });
    }
    segments.push({ text: match[1], bold: true });
    lastIndex = regex.lastIndex;
    match = regex.exec(value);
  }

  if (lastIndex < value.length) {
    segments.push({ text: value.slice(lastIndex), bold: false });
  }

  return segments.length ? segments : [{ text: value, bold: false }];
}

export function stripBoldMarkers(text = "") {
  return String(text).replace(/\*\*([^*]+)\*\*/g, "$1");
}

export function FormattedText({ text, variant = "body2", sx, emptyPlaceholder = " " }) {
  const value = String(text ?? "");

  if (!value.trim()) {
    return (
      <Typography variant={variant} color="text.disabled" sx={sx}>
        {emptyPlaceholder}
      </Typography>
    );
  }

  const lines = value.split("\n");

  return (
    <Typography
      variant={variant}
      component="div"
      sx={{ whiteSpace: "pre-wrap", lineHeight: 1.6, ...sx }}
    >
      {lines.map((line, lineIndex) => (
        <React.Fragment key={lineIndex}>
          {parseBoldSegments(line).map((segment, segmentIndex) => (
            <Box
              component="span"
              key={segmentIndex}
              sx={{ fontWeight: segment.bold ? 700 : 400 }}
            >
              {segment.text}
            </Box>
          ))}
          {lineIndex < lines.length - 1 ? <br /> : null}
        </React.Fragment>
      ))}
    </Typography>
  );
}
